// extracted by mini-css-extract-plugin
export default {"row":"List_row__7QnwH"};